import type { CancelTokenSource } from 'axios';
import Axios from 'axios';
import type { ResponseWithStatus } from './model';

export function mapResponseErrorToMessage(
  error: ResponseWithStatus<unknown>['error'],
): string | undefined {
  if (typeof error === 'string') {
    return error;
  }

  return error?.message;
}

// Please use AbortController after updating Axios to >= 0.22.0
// https://axios-http.com/docs/cancellation
export function getCancelTokenSource(): CancelTokenSource {
  return Axios.CancelToken.source();
}
